import React from "react";
import { Link } from "react-router-dom";

const DataMonitoringTabs = ({ activeTab, setActiveTab, getTabHref }) => {
  const tabNames = [
    "Data Quality Holistic",
    "Data Traffic Light",
    "Code Quality",
    "SFU Usage Metrics",
    "Cost Monitoring",
    "Platform KPI",
    "Product Usage",
    "Product View",
  ];

  return (
    <div className="dm-tabs">
      {tabNames.map((name, index) => {
        const tabId = index + 1;
        const href = getTabHref ? getTabHref(tabId) : "#";

        const handleClick = (e) => {
          const isModifiedClick =
            e.metaKey ||
            e.ctrlKey ||
            e.shiftKey ||
            e.altKey ||
            e.button !== 0;
          if (isModifiedClick) {
            return;
          }

          e.preventDefault();
          setActiveTab(tabId);
        };

        return (
          <Link
            key={index}
            to={href}
            onClick={handleClick}
            className={`dm-tab-btn ${activeTab === tabId ? "active" : ""}`}
          >
            {name}
          </Link>
        );
      })}
    </div>
  );
};

export default DataMonitoringTabs;
